import RouteDetailModal from '../components/RouteDetailModal.vue';
import Vue from 'vue';
const routeDetailModalHandler = (idRoute, events, type, idTrip) => {
  const vm = new Vue({
    ...RouteDetailModal,
    propsData: { idRoute, events, type, idTrip},
  });
  vm.$mount();
  vm.$bvModal.show('route-detail-modal');
};
export default routeDetailModalHandler;
